import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Link as ChakraLink, mode, Text, useColorMode, VStack } from '@abb/uikit';
import { Package } from '@abb/uikit/icons/outline/development';
import { FileCheck02 } from '@abb/uikit/icons/outline/files';
import { CoinsStacked04, CreditCard01, Sale02 } from '@abb/uikit/icons/outline/finance';
import { HomeLine, Percent03 } from '@abb/uikit/icons/outline/general';
import { LayersThree02 } from '@abb/uikit/icons/outline/layout';
import { ShieldTick } from '@abb/uikit/icons/outline/security';
import { UserPlus01 } from '@abb/uikit/icons/outline/users';
import { SwitchHorizontal01 } from '@abb/uikit/icons/solid/arrow';
import { useAccounts, useCheckFatca, useDependencies, useSalaryCardWhiteList, useStartLoanOdmApplication } from 'hooks';
import { ECardType, EOrderType } from 'models';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { AbbLogo } from 'shared-components/abb-logo';
import { WifiOutline } from 'shared-components/icons/sidebar';
import { hasAnyPermission, hasPermission, hasPermissionAccount } from 'utils';
import { ECustomerType } from '../models';
import { Navigation } from './Navigation';
/* eslint-disable sonarjs/cognitive-complexity */ export function Sidebar(param) {
    let { isLargerThanMd, onSidebarOpen } = param;
    var _userService_getProcessClaims, _userInfo_customers, _salaryCardWhiteList_content, _salaryCardWhiteList_content_whiteList, _salaryCardWhiteList_content1, _salaryCardWhiteList_content2;
    const { colorMode } = useColorMode();
    const { envProfileService, userService } = useDependencies();
    const { data: accounts } = useAccounts();
    const IS_PROD = envProfileService.envProfile === 'prod';
    const { t } = useTranslation('common');
    const navigate = useNavigate();
    const userInfo = userService === null || userService === void 0 ? void 0 : userService.getUserData;
    const permissionsData = userService === null || userService === void 0 ? void 0 : userService.getPermissionsData;
    const selectedCif = userService === null || userService === void 0 ? void 0 : (_userService_getProcessClaims = userService.getProcessClaims) === null || _userService_getProcessClaims === void 0 ? void 0 : _userService_getProcessClaims.customerId;
    const { data: fatca } = useCheckFatca();
    const hasSpecialSalaryPermission = hasAnyPermission(permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.permissions, [
        `${ECardType.SPECIAL_SALARY}_${EOrderType.NEW_CARD}`,
        `${ECardType.SPECIAL_SALARY}_${EOrderType.PROLONGATE_CARD}`,
        `${ECardType.SPECIAL_SALARY}_${EOrderType.RENEW_CARD}`
    ], 'view') || hasPermissionAccount(accounts === null || accounts === void 0 ? void 0 : accounts.content, selectedCif);
    const hasInsurancePermission = hasAnyPermission(permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.permissions, [
        `${ECardType.INSURANCE}_${EOrderType.NEW_CARD}`,
        `${ECardType.INSURANCE}_${EOrderType.PROLONGATE_CARD}`,
        `${ECardType.INSURANCE}_${EOrderType.RENEW_CARD}`
    ], 'view');
    const hasStudentCardPermission = hasAnyPermission(permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.permissions, [
        ECardType.STUDENT_CARD
    ], 'view');
    const hasStipendCardPermission = hasAnyPermission(permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.permissions, [
        'STIPEND_CARD_ORDER',
        'STIPEND_BLOCK_OPERATION'
    ], 'view');
    const hasCorporatePermission = hasAnyPermission(permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.permissions, [
        ECardType.CORPORATE_CARD
    ], 'view');
    const hasCustomsPermission = hasAnyPermission(permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.permissions, [
        ECardType.CUSTOMS_CARD
    ], 'view');
    const hasEntrepreneurPermission = hasAnyPermission(permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.permissions, [
        ECardType.ENTREPRENEUR_CARD
    ], 'view');
    const hasDepositPermission = hasAnyPermission(permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.permissions, [
        'DEPOSIT'
    ], 'view');
    const hasSalaryPermission = hasPermission(permissionsData, 'SPECIAL_SALARY', 'create');
    const bundleShowUserType = [
        'SME/I',
        'SME/C',
        'RKBK'
    ];
    const selectedUserInfo = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo_customers = userInfo.customers) === null || _userInfo_customers === void 0 ? void 0 : _userInfo_customers.find((item)=>item.customerId === selectedCif);
    const shouldHideForRKBKSegment = Boolean(IS_PROD && (selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.segment) === 'RKBK');
    const { data: salaryCardWhiteList } = useSalaryCardWhiteList();
    const hasSalaryCardPermission = !!(salaryCardWhiteList === null || salaryCardWhiteList === void 0 ? void 0 : (_salaryCardWhiteList_content = salaryCardWhiteList.content) === null || _salaryCardWhiteList_content === void 0 ? void 0 : _salaryCardWhiteList_content.checkWhiteList) && (salaryCardWhiteList === null || salaryCardWhiteList === void 0 ? void 0 : (_salaryCardWhiteList_content1 = salaryCardWhiteList.content) === null || _salaryCardWhiteList_content1 === void 0 ? void 0 : (_salaryCardWhiteList_content_whiteList = _salaryCardWhiteList_content1.whiteList) === null || _salaryCardWhiteList_content_whiteList === void 0 ? void 0 : _salaryCardWhiteList_content_whiteList.includes(selectedCif)) || !(salaryCardWhiteList === null || salaryCardWhiteList === void 0 ? void 0 : (_salaryCardWhiteList_content2 = salaryCardWhiteList.content) === null || _salaryCardWhiteList_content2 === void 0 ? void 0 : _salaryCardWhiteList_content2.checkWhiteList);
    const { data: loanData, onClickHandler: onClickLoanMenu } = useStartLoanOdmApplication();
    React.useEffect(()=>{
        if (loanData) {
            navigate(`/loan/order/${loanData.data.id}`);
            setTimeout(()=>{
                location.hash = 'calculator';
            }, 1000);
        }
    }, [
        loanData
    ]);
    const cardsSubmenu = !hasSpecialSalaryPermission || !IS_PROD ? [
        {
            id: 'sidebar-salary-cards-link',
            title: t('menu.salary_card'),
            href: '/cards/salary',
            prefetch: false,
            isNew: false,
            isDisabled: !hasSalaryCardPermission,
            disabledText: t('menu.cardsDisabledText')
        },
        {
            id: 'sidebar-stipend-cards-link',
            title: t('menu.stipend_card'),
            href: '/cards/stipend',
            prefetch: false,
            isNew: false,
            isDisabled: !hasStipendCardPermission,
            disabledText: t('menu.cardsDisabledText'),
            isHidden: !hasStipendCardPermission
        },
        {
            id: 'sidebar-business-cards-link',
            title: t('menu.business_card'),
            href: '/cards/business',
            prefetch: false,
            isNew: false,
            isDisabled: !hasSalaryCardPermission,
            disabledText: t('menu.cardsDisabledText')
        },
        {
            id: 'sidebar-customs-cards-link',
            title: t('menu.customs_card'),
            href: '/special-cards/customs',
            prefetch: false,
            isNew: false,
            isHidden: !hasCustomsPermission && !(selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.director)
        },
        {
            id: 'sidebar-entrepreneur-cards-link',
            title: t('menu.entrepreneur_card'),
            href: '/special-cards/entrepreneur',
            prefetch: false,
            isHidden: !hasEntrepreneurPermission && ((selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.customerType) === ECustomerType.CORPORATE || (selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.vatPayer) || !(selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.director)),
            isNew: false
        },
        {
            id: 'sidebar-corporate-cards-link',
            title: t('menu.corporate_card'),
            href: '/special-cards/corporate',
            prefetch: false,
            isHidden: !hasCorporatePermission && ((selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.customerType) === ECustomerType.INDIVIDUAL && !(selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.vatPayer) || !(selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.director)),
            isNew: false
        },
        {
            id: 'sidebar-insurance-card-link',
            title: t('menu.universal_card'),
            href: '/insurance',
            prefetch: false,
            submenu: [],
            isNew: false,
            isHidden: !hasInsurancePermission || shouldHideForRKBKSegment
        },
        {
            id: 'sidebar-special-salary-card-link',
            title: t('menu.special_salary_card'),
            href: '/salary-cards-special',
            prefetch: false,
            submenu: [],
            isNew: false,
            isHidden: !hasSpecialSalaryPermission && IS_PROD || shouldHideForRKBKSegment
        },
        {
            id: 'sidebar-service-card-link',
            title: t('menu.service_card'),
            href: '/service',
            prefetch: false,
            submenu: [],
            isNew: false,
            isHidden: (selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.customerType) === ECustomerType.CORPORATE && IS_PROD
        },
        {
            id: 'sidebar-student-card-link',
            title: t('menu.student_card'),
            href: '/student-card',
            prefetch: false,
            submenu: [],
            isNew: false,
            isHidden: !hasStudentCardPermission
        },
        {
            id: 'sidebar-reports-link',
            title: t('menu.reports'),
            href: '/reports',
            prefetch: false,
            submenu: [],
            isNew: false
        }
    ] : [
        {
            id: 'sidebar-special-salary-card-link',
            title: t('menu.special_salary_card'),
            href: '/salary-cards-special',
            prefetch: false,
            submenu: [],
            isNew: false
        }
    ];
    const accountSubMenu = [
        {
            id: 'sidebar-account-link',
            title: t('menu.account_extracts'),
            href: '/accounts',
            prefetch: false,
            submenu: [],
            isNew: (fatca === null || fatca === void 0 ? void 0 : fatca.fatcaStatus) === 'OLD'
        },
        {
            id: 'sidebar-orders-link',
            title: t('menu.orders'),
            href: '/orders?page=1',
            prefetch: false,
            submenu: [],
            isNew: false
        },
        {
            id: 'sidebar-sms-email-notification-link',
            title: t('menu.sms_email_notification'),
            href: '/sms-email-notification',
            prefetch: false,
            submenu: [],
            isHidden: !(selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.director),
            isNew: true
        },
        {
            id: 'sidebar-swift-inbound-tracking-link',
            title: t('menu.swift_inbound_tracking'),
            href: '/swift-inbound-tracking?page-number=1&page-size=10',
            prefetch: false,
            submenu: [],
            isNew: true
        }
    ];
    const depositSubMenu = [
        {
            id: 'sidebar-new-order-link',
            title: t('menu.new_order'),
            href: '/deposits/create',
            prefetch: true,
            isHidden: !(selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.director) || (selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.customerType) !== 'C',
            isNew: false
        },
        {
            id: 'sidebar-deposit-history-link',
            title: t('menu.existing_deposit'),
            href: '/deposits?page-number=1&page-size=10',
            prefetch: false,
            isHidden: !hasDepositPermission,
            isNew: false
        },
        {
            id: 'sidebar-order-history-link',
            title: t('menu.order_history'),
            href: '/deposits/order-history?page-number=1&page-size=10',
            prefetch: false,
            isHidden: !(selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.director) || (selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.customerType) !== 'C',
            isNew: false
        }
    ];
    const posSubMenu = [
        {
            id: 'sidebar-pos-link',
            title: t('menu.pos_orders'),
            href: '/pos',
            prefetch: false,
            submenu: [],
            isNew: false
        },
        {
            id: 'sidebar-pos-statements-link',
            title: t('menu.pos_statements'),
            href: '/pos/statements',
            prefetch: false,
            submenu: [],
            isNew: false
        },
        {
            id: 'sidebar-pos-analytics-link',
            title: t('menu.pos_analytics'),
            href: '/pos-analytics/transactions',
            prefetch: false,
            submenu: [],
            isNew: true
        }
    ];
    const transferSubMenu = [
        {
            id: 'sidebar-payments-link',
            title: t('menu.payment'),
            href: '/payments?page=1',
            prefetch: false,
            submenu: [],
            isNew: false,
            isHidden: hasSalaryPermission
        },
        {
            id: 'sidebar-gpp-link',
            title: t('menu.gpp'),
            href: '/hop/create',
            prefetch: false,
            submenu: [],
            isHidden: hasSalaryPermission
        },
        {
            id: 'sidebar-anipay-link',
            title: t('menu.anipay'),
            href: '/anipay?tab=anipay&page=1',
            prefetch: false,
            submenu: [],
            isHidden: hasSalaryPermission
        },
        {
            id: 'sidebar-dgk-link',
            title: t('menu.dgk'),
            href: '/dgk?page-number=1&page-size=10',
            prefetch: false,
            submenu: [],
            isNew: false,
            isHidden: hasSalaryPermission
        },
        {
            id: 'sidebar-salary-link',
            title: t('menu.salary_payment'),
            href: '/payments/salary-payment-special?page=1',
            prefetch: false,
            submenu: [],
            isNew: false,
            isHidden: !hasSalaryPermission
        }
    ];
    const approvementSubmenu = [
        {
            id: 'sidebar-approvement-transfer-link',
            title: t('menu.payment'),
            href: '/approvement/transfer/pending',
            prefetch: false
        },
        {
            id: 'sidebar-approvement-cards-link',
            title: t('menu.cards'),
            href: '/approvement/cards/pending',
            prefetch: false,
            isNew: false
        },
        {
            id: 'sidebar-approvement-payments-link',
            title: t('menu.gpp'),
            href: '/approvement/payments/pending',
            prefetch: false,
            isNew: false
        },
        {
            id: 'sidebar-approvement-salary-payment-link',
            title: t('menu.salary_payment'),
            href: '/approvement/salary/pending',
            prefetch: false
        },
        {
            id: 'sidebar-approvement-bulk-link',
            title: t('menu.bulk_payments'),
            href: '/approvement/bulk/pending',
            prefetch: false,
            isNew: false
        },
        {
            id: 'sidebar-approvement-anipay-link',
            title: t('menu.anipay'),
            href: '/approvement/anipay/pending',
            prefetch: false,
            isNew: false
        },
        {
            id: 'sidebar-approvement-bundle-link',
            title: t('menu.bundle'),
            href: '/approvement/bundle',
            prefetch: false,
            isNew: false
        },
        {
            id: 'sidebar-approvement-e-wallet-link',
            title: t('menu.e-wallet'),
            href: '/approvement/e-wallet/pending',
            prefetch: false,
            isNew: true
        },
        {
            id: 'sidebar-approvement-contract-link',
            title: t('menu.contracts'),
            href: '/approvement/contracts',
            prefetch: false,
            isNew: false
        }
    ];
    const businessApiSubmenu = [
        {
            id: 'sidebar-erp-transfer-link',
            title: t('menu.payments_authorization'),
            href: '/erp/transfer/pending',
            prefetch: false
        },
        {
            id: 'sidebar-erp-salary-link',
            title: t('menu.salary_payments_authorization'),
            href: '/erp/erpsalary/pending',
            prefetch: false
        },
        {
            id: 'sidebar-cards-order-link',
            title: t('menu.card_order_approvement'),
            href: '/erp/cards',
            prefetch: false,
            isNew: true
        },
        {
            id: 'sidebar-api-bundles-link',
            title: t('menu.api_bundles'),
            href: '/erp/api-packages',
            prefetch: false,
            isNew: false
        }
    ];
    const loansSubMenu = [
        {
            id: 'sidebar-new-order-link',
            title: t('menu.new_order'),
            href: '/loan/order-apply',
            prefetch: false,
            isNew: false,
            isHidden: false
        },
        {
            id: 'sidebar-loan-odm-link',
            title: t('menu.loan_odm'),
            href: '',
            onClick: onClickLoanMenu,
            prefetch: false,
            isNew: true,
            isHidden: IS_PROD
        },
        {
            id: 'sidebar-loan-history-link',
            title: t('menu.loan_history'),
            href: '/loan?page-number=1&page-size=10',
            prefetch: false,
            isNew: false,
            isHidden: shouldHideForRKBKSegment
        },
        {
            id: 'sidebar-order-history-link',
            title: t('menu.order_history'),
            href: '/loan/order-history?page-number=1&page-size=10',
            prefetch: false,
            isNew: false,
            isHidden: shouldHideForRKBKSegment
        },
        {
            id: 'sidebar-mkr-history-link',
            title: t('menu.mkr'),
            href: '/mkr',
            prefetch: false,
            isNew: true,
            isHidden: shouldHideForRKBKSegment
        },
        {
            id: 'sidebar-contract-sign',
            title: t('menu.loan_contracts'),
            href: '/contract-sign?page-number=1&page-size=10',
            prefetch: false,
            isNew: true,
            isHidden: shouldHideForRKBKSegment
        }
    ];
    const guaranteeSubMenu = [
        {
            id: 'sidebar-new-order-link',
            title: t('menu.new_order'),
            href: '/guarantee/new-apply',
            prefetch: true,
            isHidden: false,
            isNew: false
        },
        {
            id: 'sidebar-loan-history-link',
            title: t('menu.existing_contract'),
            href: '/guarantee?page-number=1&page-size=10',
            prefetch: false,
            isHidden: false,
            isNew: false
        },
        {
            id: 'sidebar-order-history-link',
            title: t('menu.order_history'),
            href: '/guarantee/order-history?page-number=1&page-size=10',
            prefetch: false,
            isHidden: false,
            isNew: false
        },
        {
            id: 'sidebar-report-link',
            title: t('menu.guarantee-report'),
            href: '/guarantee/report',
            prefetch: false,
            isNew: true,
            isHidden: !Boolean(selectedCif === '9325068')
        }
    ];
    return /*#__PURE__*/ _jsxs(Box, {
        as: "aside",
        position: {
            base: 'relative',
            md: 'fixed'
        },
        insetY: 0,
        display: "flex",
        height: "auto",
        p: "8px 12px",
        flexGrow: {
            base: 0,
            md: 1
        },
        flexDirection: "column",
        width: isLargerThanMd ? '272px' : '100%',
        background: mode('#F0F0F0', '#0A0B0D')({
            colorMode
        }),
        children: [
            isLargerThanMd && /*#__PURE__*/ _jsx(ChakraLink, {
                as: Link,
                textAlign: "left",
                to: "/dashboard",
                pl: {
                    base: 0,
                    md: '20px'
                },
                mb: {
                    base: 0,
                    md: '36px'
                },
                mt: {
                    base: 0,
                    md: '24px'
                },
                display: "block",
                children: /*#__PURE__*/ _jsx(AbbLogo, {})
            }),
            /*#__PURE__*/ _jsxs(VStack, {
                justify: "space-between",
                height: {
                    base: 'auto',
                    md: '100dvh'
                },
                overflowY: "scroll",
                p: "0",
                css: {
                    '&::-webkit-scrollbar': {
                        width: '0px'
                    },
                    '&::-webkit-scrollbar-track': {
                        width: '3px'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: '#ffffff14',
                        borderRadius: '36px'
                    }
                },
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        w: "100%",
                        children: /*#__PURE__*/ _jsx(Box, {
                            w: "100%",
                            children: /*#__PURE__*/ _jsx(Navigation, {
                                links: [
                                    {
                                        id: 'sidebar-dashboard-link',
                                        icon: HomeLine,
                                        title: t('menu.dashboard'),
                                        href: '/dashboard',
                                        prefetch: false,
                                        submenu: [],
                                        isNew: false
                                    },
                                    {
                                        id: 'sidebar-accounts-link',
                                        icon: LayersThree02,
                                        title: t('menu.accounts'),
                                        href: '/accounts',
                                        prefetch: false,
                                        submenu: accountSubMenu,
                                        isNew: false
                                    },
                                    {
                                        id: 'sidebar-deposit-link',
                                        icon: CoinsStacked04,
                                        title: t('menu.deposit'),
                                        href: '/deposits?page-number=1&page-size=10',
                                        prefetch: false,
                                        submenu: depositSubMenu,
                                        isHidden: !(selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.director) && !hasDepositPermission,
                                        isNew: false
                                    },
                                    {
                                        id: 'sidebar-payments-link',
                                        icon: SwitchHorizontal01,
                                        title: t('menu.sidebar_transfer'),
                                        href: '/payments?page=1',
                                        prefetch: false,
                                        submenu: transferSubMenu,
                                        isNew: false
                                    },
                                    {
                                        id: 'sidebar-cards-link',
                                        icon: CreditCard01,
                                        title: t('menu.cards'),
                                        href: '',
                                        prefetch: false,
                                        submenu: cardsSubmenu,
                                        isNew: false
                                    },
                                    {
                                        id: 'sidebar-bundle-link',
                                        icon: Sale02,
                                        title: t('menu.bundle'),
                                        href: '/tariff-packages',
                                        prefetch: false,
                                        submenu: [],
                                        isNew: true,
                                        isHidden: (selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.segment) && !bundleShowUserType.includes(selectedUserInfo.segment.toUpperCase())
                                    },
                                    {
                                        id: 'pos-terminal-link',
                                        icon: WifiOutline,
                                        title: t('menu.pos'),
                                        href: '',
                                        prefetch: false,
                                        submenu: posSubMenu,
                                        isNew: false
                                    },
                                    {
                                        id: 'sidebar-loan-link',
                                        icon: Percent03,
                                        title: t('menu.loan'),
                                        href: IS_PROD ? '/loan?page-number=1&page-size=10' : '',
                                        prefetch: false,
                                        submenu: loansSubMenu,
                                        isNew: false,
                                        isHidden: false
                                    },
                                    {
                                        id: 'sidebar-supply-link',
                                        icon: Package,
                                        title: t('menu.supply_chain'),
                                        href: '/supply-chain',
                                        prefetch: false,
                                        submenu: [],
                                        isNew: true,
                                        isHidden: false
                                    },
                                    {
                                        id: 'sidebar-guarantee-link',
                                        icon: ShieldTick,
                                        title: t('menu.guarantee'),
                                        href: '/guarantee?page-number=1&page-size=10',
                                        prefetch: false,
                                        submenu: guaranteeSubMenu,
                                        isNew: false
                                    },
                                    {
                                        id: 'sidebar-approvement-link',
                                        icon: FileCheck02,
                                        title: t('menu.waiting_for_approval'),
                                        href: '',
                                        prefetch: false,
                                        submenu: approvementSubmenu,
                                        isNew: false
                                    },
                                    {
                                        id: 'sidebar-business-api-link',
                                        icon: FileCheck02,
                                        title: t('menu.business_api'),
                                        href: '',
                                        prefetch: false,
                                        submenu: businessApiSubmenu,
                                        isNew: true
                                    }
                                ],
                                onSidebarOpen: onSidebarOpen
                            })
                        })
                    }),
                    isLargerThanMd && (selectedUserInfo === null || selectedUserInfo === void 0 ? void 0 : selectedUserInfo.director) && /*#__PURE__*/ _jsx(Box, {
                        width: "100%",
                        children: /*#__PURE__*/ _jsxs(Button, {
                            as: Link,
                            variant: "outline",
                            to: "/accountopening",
                            _active: {
                                borderRadius: '8px'
                            },
                            p: "12px 20px 12px 16px",
                            width: "100%",
                            borderColor: "rgba(10, 11, 13, 0.08)",
                            gap: 2,
                            borderRadius: "12px",
                            height: "auto",
                            bg: mode('rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 0.04)')({
                                colorMode
                            }),
                            onClick: ()=>onSidebarOpen ? onSidebarOpen() : undefined,
                            children: [
                                /*#__PURE__*/ _jsx(UserPlus01, {}),
                                /*#__PURE__*/ _jsx(Text, {
                                    fontWeight: 500,
                                    fontSize: {
                                        base: 'lg',
                                        md: 'sm'
                                    },
                                    textDecoration: "none",
                                    children: t('menu.new_account')
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
